import scopedObjBuilder from '../../scopedObjBuilder';
import type { IRiveProps } from './Rive.props';

export type LayoutType<T> = { key: string; value: T };

export type FitRiveTypes =
  | 'layout'
  | 'cover'
  | 'contain'
  | 'fill'
  | 'fitWidth'
  | 'fitHeight'
  | 'none'
  | 'scaleDown';

export type AlignmentRiveTypes =
  | 'center'
  | 'topLeft'
  | 'topCenter'
  | 'topRight'
  | 'bottomLeft'
  | 'bottomCenter'
  | 'bottomRight';

export const Fit: Record<FitRiveTypes, LayoutType<FitRiveTypes>> = {
  cover: {
    key: 'Rive.settings.panel-Fit-Cover-Label',
    value: 'cover',
  },
  contain: {
    key: 'Rive.settings.panel-Fit-Contain-Label',
    value: 'contain',
  },
  fill: {
    key: 'Rive.settings.panel-Fit-Fill-Label',
    value: 'fill',
  },
  fitWidth: {
    key: 'Rive.settings.panel-Fit-FitWidth-Label',
    value: 'fitWidth',
  },
  fitHeight: {
    key: 'Rive.settings.panel-Fit-FitHeight-Label',
    value: 'fitHeight',
  },
  none: {
    key: 'Rive.settings.panel-Fit-None-Label',
    value: 'none',
  },
  scaleDown: {
    key: 'Rive.settings.panel-Fit-ScaleDown-Label',
    value: 'scaleDown',
  },
  layout: {
    key: 'Rive.settings.panel-Fit-Layout-Label',
    value: 'layout',
  },
} as const;

export const Alignment: Record<
  AlignmentRiveTypes,
  LayoutType<AlignmentRiveTypes>
> = {
  center: {
    key: 'Rive.settings.panel-Align-Center-Label',
    value: 'center',
  },
  topLeft: {
    key: 'Rive.settings.panel-Align-TopLeft-Label',
    value: 'topLeft',
  },
  topCenter: {
    key: 'Rive.settings.panel-Align-TopCenter-Label',
    value: 'topCenter',
  },
  topRight: {
    key: 'Rive.settings.panel-Align-TopRight-Label',
    value: 'topRight',
  },
  bottomLeft: {
    key: 'Rive.settings.panel-Align-BottomLeft-Label',
    value: 'bottomLeft',
  },
  bottomCenter: {
    key: 'Rive.settings.panel-Align-BottomCenter-Label',
    value: 'bottomCenter',
  },
  bottomRight: {
    key: 'Rive.settings.panel-Align-BottomRight-Label',
    value: 'bottomRight',
  },
} as const;

export const helpIds = {
  settingsPanelInfo: '7ac81c23-2ba9-4c9b-b60e-f1a977e2f45f',
  GFPPInfo: '05c9d2a0-8a60-4866-95c3-3217f8f17b6e',
};

const settingsPanelPrefix = scopedObjBuilder('rive');
export const testIds = {
  ...settingsPanelPrefix('settingsPanel', [
    'root',
    'playAnimation_iconButton',
    'animationFileName_input',
    'changeFile_textButton',
    'artboard_dropDown',
    'stateMachine_dropDown',
    'fit_dropDown',
    'alignment_dropDown',
    'autoPlay_toggleSwitch',
    'touchScroll_toggleSwitch',
    'alt_input',
  ]),
} as const;

export const defaultTestCompProps: Omit<
  IRiveProps,
  | 'updateComponentPropsInViewer'
  | 'reducedMotion'
  | ' metaSiteId'
  | 'isInPreviewMode'
> = {
  id: 'riveTest',
  animationFileUrl:
    'https://public.rive.app/community/runtime-files/14415-28584-cat.riv',
  thumbnailFileUrl: 'https://www.iconsdb.com/icons/preview/gray/square-xxl.png',
  artboard: 'Cat & Treat',
  stateMachine: 'State Machine 1',
  fit: Fit.cover.value,
  alignment: Alignment.center.value,
  isAutoPlayOn: true,
  isTouchScrollEnabled: true,
  alt: 'cat animation',
  fileName: 'cat.riv',
  metaSiteId: '',
  topology: undefined,
  isDecorative: false,
};
